import { getNegColor, getPosColor, getRGBAColor, hexToRgb } from '../helpers/helpers'

export const useMatrixFilterColor = () =>
	function ({
		field,
		played,
		fieldMax,
		fieldMin,
		matrixRange,
		matrixEquity,
		matrixEv,
		matrixEqr,
		maxEquityRealization = 0,
		minEquityRealization = 0,
	}) {
		const { maxRange, minRange } = matrixRange
		const { maxEquity, midEquity, minEquity } = matrixEquity
		const { zeroEV, posEV, negEV } = matrixEv
		const { minEqr, midEqr, maxEqr } = matrixEqr

		const minRangeColor = hexToRgb(minRange)
		const maxRangeColor = hexToRgb(maxRange)
		const minEquityColor = hexToRgb(minEquity)
		const midEquityColor = hexToRgb(midEquity)
		const maxEquityColor = hexToRgb(maxEquity)
		const zeroEvColor = hexToRgb(zeroEV)
		const posEvColor = hexToRgb(posEV)
		const negEvColor = hexToRgb(negEV)
		const minEqrColor = hexToRgb(minEqr)
		const midEqrColor = hexToRgb(midEqr)
		const maxEqrColor = hexToRgb(maxEqr)

		let fillColor

		switch (true) {
			case field === 'abs':
				fillColor = getPosColor(minRangeColor, maxRangeColor, played * 100, 100)
				break
			case field === 'eq' && played <= 0.5:
				fillColor = getPosColor(minEquityColor, midEquityColor, played * 100, 50)
				break

			case field === 'eq' && played > 0.5:
				fillColor = getPosColor(midEquityColor, maxEquityColor, (played - 0.5) * 100, 50)
				break

			case field === 'eqr' && played <= 1:
				fillColor = getRGBAColor(minEqrColor, midEqrColor, 1 - played)
				break

			case field === 'eqr' && played > 1:
				fillColor = getRGBAColor(midEqrColor, maxEqrColor, 1 - (played - 1) / (maxEquityRealization - 1))
				break

			case field === 'ev' && played > 0:
				fillColor = getPosColor(zeroEvColor, posEvColor, played, fieldMax)

				break
			case field === 'ev' && played === 0:
				fillColor = `rgba(${zeroEvColor.filter(Boolean).join(',')})`
				break
			case field === 'ev' && played < 0:
				fillColor = getNegColor(zeroEvColor, negEvColor, played, fieldMax, fieldMin)
				break
		}

		return fillColor
	}

export const useGradientColor =
	() =>
	({ value, maxColor, minColor }) => {
		const absVal = Math.abs(value)

		const maxRgbColor = hexToRgb(maxColor)
		const minRgbColor = hexToRgb(minColor)

		return getRGBAColor(minRgbColor, maxRgbColor, 1 - absVal)
	}
